// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var AttachmentSettingsEditController = function ($scope,
    $routeParams,
    gettext,
    gettextCatalog,
    Attachment,
    DownloadService) {

    $scope.isError = false;
    $scope.errorMessage = '';

    if ($routeParams.id) {
        $scope.attachment = Attachment.get({ id: $routeParams.id }, function () {});
    } else {
        if (!$scope.attachment) {
            $scope.attachment = {
                Id: '000000000000000000000000',
                InternalName: '',
                Files: {
                    '_c':
                    {
                        FileId: '000000000000000000000000',
                        FileName: '',
                        FileSize: ''
                    }
                }
            };
        }
    }

    $scope.$watch('errorMessage', function (newValue) {
        if (newValue) {
            $scope.notify('error', 'Upload error: ' + newValue);
            $scope.errorMessage = '';
        }
    });

    $scope.download = function (attachmentId) {
        var downloadInfo = new DownloadService();
        downloadInfo.$get({ id: attachmentId },
            function () {
                window.location = downloadInfo.Url;
            });
    };

    $scope.removeFile = function () {
        if ($scope.isNew()) {
            $scope.deleteFunc();
        } else {
            $scope.yesCancel(gettextCatalog.getString(gettext('Delete File')),
                gettextCatalog.getString(gettext('Are you sure?')),
                function () { $scope.deleteFunc(); }
            );
        }
    };  

    $scope.onSuccessCallback = function () {
        window.location = '#/settings/attachments-list'; 
    };   

    $scope.save = function () {
        var fileName = $scope.attachment.Files['_c'].FileName;
        var uploaderVal = document.getElementById('uploadFile').value;
        if ($scope.isSavingForbidden()) {
            $scope.errorMessage = 'Nothing to save yet. Please Upload file at first.';
        } else {
            if (uploaderVal === '' && fileName) {
            $scope.putFunc();
            } else {
                $scope.saveFunc();
            }
        }
    };
    $scope.isSavingForbidden = function() {
        var fileName = $scope.attachment.Files['_c'].FileName;
        var uploaderVal = document.getElementById('uploadFile').value;
        if (uploaderVal === '' && !fileName)
            return true;
        return false;
    }
    $scope.putFunc = function () {
        $scope.attachment.$update({ attachmentId: $scope.attachment.Id }, function () {
            console.log("item updated");
            $scope.onSuccessCallback();
        });
    };

    $scope.getFileUploaderText = function () {
        return $scope.isEmpty() ? gettextCatalog.getString(gettext('Select')) : gettextCatalog.getString(gettext('Replace'));
    };
    $scope.getHeaderText =  $scope.isEmpty? gettextCatalog.getString(gettext('Create Attachment')) : gettextCatalog.getString(gettext('Edit Attachment'));

    $scope.isNew = function () {
        return $scope.attachment.Id === '';
    };

    $scope.isEmpty = function () {
        return !$scope.attachment.Files || $scope.attachment.Files['_c'].FileSize === '';
    };
    $scope.dataInvalid = function() {
        return $scope.editAttachment.internalName.$invalid || $scope.isSavingForbidden();
    };
};

AttachmentSettingsEditController.$inject = ['$scope', '$routeParams', 'gettext', 'gettextCatalog', 'Attachment', 'DownloadService'];